import type {
  AzureSubscriptionRecord,
  QuickLaunchLink,
  Resource,
  ResourceGroup,
  Subnet,
} from 'cmp-client-api';

import type { AzureSubscriptionInterface } from '@src/domain/types';
import type { MapperInterface } from '@src/server/converters/types/mapper.interface';
import { BrownfieldResourceInterface } from '@src/domain/pages/automation/provisioning/components/types/brownfield-resource.interface';
import { BrownfieldResourceTypeEnum } from '@src/domain/pages/automation/provisioning/components/types/brownfield-resource-type.enum';

const transformFromApiModel = (
  apiModel: AzureSubscriptionRecord[]
): AzureSubscriptionInterface[] => {
  const subscriptionInterfaceList: AzureSubscriptionInterface[] = [];

  apiModel.forEach((modelContent) => {
    const azureSubscription = modelContent.azureCloud.map((item) => ({
      name: modelContent.name,
      subscriptionId: item.subscriptionId,
      appId: item.appId,
      scu: modelContent.customerScu,
    }));

    subscriptionInterfaceList.push(...azureSubscription);
  });

  return subscriptionInterfaceList;
};

const transformFromQuickLaunchLinkApiModel = (apiModel: QuickLaunchLink[]): QuickLaunchLink[] =>
  apiModel.map((modelContent) => {
    const { url, displayName } = modelContent;

    return {
      url,
      displayName,
    };
  });

const transformFromResourceGroupApiModel = (
  apiModel: ResourceGroup[]
): BrownfieldResourceInterface[] =>
  apiModel.map((modelContent) => {
    const { id, name, type } = modelContent;

    return {
      id,
      name,
      type: type as BrownfieldResourceTypeEnum,
    };
  });

const transformFromVirtualNetworkApiModel = (apiModel: Resource[]): BrownfieldResourceInterface[] =>
  apiModel.map((modelContent) => {
    const { id, name, type } = modelContent;

    return {
      id,
      name,
      type: type as BrownfieldResourceTypeEnum,
    };
  });

const transformFromSubnetApiModel = (apiModel: Subnet[]): BrownfieldResourceInterface[] =>
  apiModel.map((modelContent) => {
    const { id, name, type } = modelContent;

    return {
      id,
      name,
      type: type as BrownfieldResourceTypeEnum,
    };
  });

export const AzureSubscriptionMapper: MapperInterface<
  AzureSubscriptionInterface[],
  AzureSubscriptionRecord[]
> = { transformFromApiModel };

export const AzureSubscriptionQuickLaunchMapper: MapperInterface<
  QuickLaunchLink[],
  QuickLaunchLink[]
> = { transformFromApiModel: transformFromQuickLaunchLinkApiModel };

export const BrownfieldProvisioningMapper: MapperInterface<
  BrownfieldResourceInterface[],
  ResourceGroup[]
> = { transformFromApiModel: transformFromResourceGroupApiModel };

export const BrownfieldProvisioningVirtualNetworkMapper: MapperInterface<
  BrownfieldResourceInterface[],
  Resource[]
> = { transformFromApiModel: transformFromVirtualNetworkApiModel };

export const BrownfieldProvisioningSubnetMapper: MapperInterface<
  BrownfieldResourceInterface[],
  Subnet[]
> = { transformFromApiModel: transformFromSubnetApiModel };
